// config/config.js
const config = {
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3000",
  useLocalData: import.meta.env.VITE_USE_LOCAL_DATA === "true" || false,
};

export default config;
